import { Injectable, OnInit } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpErrorResponse,
  HttpResponse,
  HttpBackend
} from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { LiveRouteConsol } from '../models/live-route-consol';
import { ParcelHistories } from '../models/parcel-histories';
import { catchError, delay, share, timeout } from 'rxjs/operators';
import { Observable, EMPTY, of } from 'rxjs';
import { DTOCredentials } from '../models/dto-credentials';
import { DTOUserId } from '../models/dto-user-id';
import { DTOResetPassword } from '../models/dto-reset-password';
import { LogService } from '../../@core/services/logger.service';
import { LogLevel } from '../../@core/services/logger.service';
import { ToastrService } from 'ngx-toastr';
import { DTOUserEmail } from '../models/dto-user-email';
import { NatUserStates } from '../models/nat-user-state';
import { PickupHistories } from '../models/pickup-histories';
import { OnHoldTabStatus } from '../models/onhold-tab-status';
import { OnholdTab } from '../models/onhold-tab';
import { AddressGroup } from '../models/dto-address-group';
import { DTODailyManifest } from '../models/dto-daily-manifest';
import {
  Stops,
  SectorCompress,
  Stop,
  TpslRouteStops
} from '../models/live-route';
import { DTOParcelRoute } from '../models/DTOParcelRoute';
import { DatePipe } from '@angular/common';
import { RouteStatus } from '../models/dto-routestatus';
import { ParcelHistory } from '../models/parcelhistory';
import { WebPage } from '../models/WebPage';
import { RouteModel } from '../models/route';
import { LocationModel } from '../models/location';
import { DevicePositionHistory } from '../models/DevicePositionHistory';
import { DtoModifAddress } from '../models/dto-modifaddress';
import { SearchDealersRequest, DealerResponse } from '../models/pudo';
import { RouteStops } from '../models/dto-route-stops';
import { MobileUser } from '../models/MobileUser';
import { DropOffPoint } from '../models/dropoffpoint';
import { Photo } from '../models/photo';
import { DTOShipment } from '../models/DTOShipment';
import { DTOParcelHistories } from '../models/DTOParcelHistories';
import { DTOShipmentAdvancedSearch } from '../models/DTOShipmentAdvancedSearch';
import { DTOPODContact } from '../models/DTOPODContact';
import { DTOCustomerInfo } from '../models/DTOCustomerInfo';
import { DTOShipmentCreate } from '../models/DTOShipmentCreate';
import { DTOShipmentCreated } from '../models/DTOShipmentCreated';
import { Customer } from '../models/Customer';
import { ENotificationType } from '../models/e-notification-type';
import { GeoTabUser } from '../models/geoab-user';
import { GeoTabUserAssign } from '../models/geoab-user-assign';

@Injectable()
export class ApiProvider implements OnInit {
  private _baseUrl: string = environment.apiUrl;

  private _requestHeaders: HttpHeaders = new HttpHeaders().set(
    'Authorization',
    '*NationexInternalAPI*'
  );

  private _httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: '*NationexInternalAPI*'
    })
  };

  private requestHeaders2: HttpHeaders = this._requestHeaders
    .set('Access-Control-Allow-Origin', '*')
    .set('Access-Control-Allow-Methods', 'GET,HEAD,OPTIONS,POST,PUT')
    .set('Access-Control-Allow-Headers', 'Origin, Content-Type, X-Auth-Token');

  constructor(
    private http: HttpClient,
    private handler: HttpBackend,
    private logger: LogService,
    private toastservice: ToastrService,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    this.http.post<boolean>(environment.apiUrl, '', {
      headers: this.requestHeaders2
    });
  }
  /*
   * Build the api url call with the provided method name
   */
  private getApiUrlCall(methodName: string): string {
    let url = '';

    url = this._baseUrl + methodName;

    return url;
  }

  /**
   * Returns all rows from nationex.live_route for a particular date and routeID
   * Does not filter rows which should not be displayed
   */
  public getLiveRouteFromRouteID(
    routeID: number,
    routeDate: Date
  ): Observable<LiveRouteConsol[]> {
    const url = this.getApiUrlCall('api/v3/LiveRoutes');
    let params = new HttpParams();
    params = params.append('id', routeID.toString());
    params = params.append(
      'date',
      this.datePipe.transform(routeDate, 'yyyy-MM-dd')
    );

    const response = this.http
      .get<LiveRouteConsol[]>(url, {
        params: params,
        headers: this._requestHeaders
      })
      .pipe(share());

    return response;
  }

  /**
   * Returns all On hold for specific exceptions
   * */
  public getLiveRouteOnHold(
    routeDate: Date,
    ExceptionTab: OnholdTab
  ): LiveRouteConsol[] {
    // TO DO : Call Endpoint to get all on hold item.
    const list: LiveRouteConsol[] = [];
    switch (ExceptionTab.Status) {
      case OnHoldTabStatus.EnAttente:
        const oneliverouteconsol: LiveRouteConsol = new LiveRouteConsol();
        oneliverouteconsol.LiveRouteID = 1223456;
        oneliverouteconsol.CustomerName = 'Clientattente';
        list.push(oneliverouteconsol);
        break;
      case OnHoldTabStatus.NatFlex:
        const oneliverouteconsolattente: LiveRouteConsol =
          new LiveRouteConsol();
        oneliverouteconsolattente.LiveRouteID = 12256789;
        oneliverouteconsolattente.CustomerName = 'Clientnatflex';
        list.push(oneliverouteconsolattente);
        break;
      case OnHoldTabStatus.Manifest:
        const oneliverouteconsolmanifest: LiveRouteConsol =
          new LiveRouteConsol();
        oneliverouteconsolmanifest.LiveRouteID = 123679;
        oneliverouteconsolmanifest.CustomerName = 'Clientclientmanifest';
        list.push(oneliverouteconsolmanifest);
        break;
      case OnHoldTabStatus.Code3:
        const oneliverouteconsolcode3: LiveRouteConsol = new LiveRouteConsol();
        oneliverouteconsolcode3.LiveRouteID = 123623;
        oneliverouteconsolcode3.CustomerName = 'Clientclientcode3';
        list.push(oneliverouteconsolcode3);
        break;
      case OnHoldTabStatus.Code9:
        const oneliverouteconsolcode9: LiveRouteConsol = new LiveRouteConsol();
        oneliverouteconsolcode9.LiveRouteID = 123620;
        oneliverouteconsolcode9.CustomerName = 'Clientclientcode9';
        list.push(oneliverouteconsolcode9);
        break;
      case OnHoldTabStatus.Code17:
        const oneliverouteconsolcode17: LiveRouteConsol = new LiveRouteConsol();
        oneliverouteconsolcode17.LiveRouteID = 123620;
        oneliverouteconsolcode17.CustomerName = 'Clientclientcode17';
        list.push(oneliverouteconsolcode17);
        break;
      case OnHoldTabStatus.Code19:
        const oneliverouteconsolcode19: LiveRouteConsol = new LiveRouteConsol();
        oneliverouteconsolcode19.LiveRouteID = 123620;
        oneliverouteconsolcode19.CustomerName = 'Clientclientcode19';
        list.push(oneliverouteconsolcode19);
        break;
      case OnHoldTabStatus.Code41:
        const oneliverouteconsolcode41: LiveRouteConsol = new LiveRouteConsol();
        oneliverouteconsolcode41.LiveRouteID = 123620;
        oneliverouteconsolcode41.CustomerName = 'Clientclientcode41';
        list.push(oneliverouteconsolcode19);
        break;
      default:
    }
    return list;
  }
  /**
   ** Inserts live route group address
   **/
  public insertLiveRouteGroupAddress(
    group: AddressGroup[]
  ): Observable<boolean> {
    if (group.length === 0) return of(true);

    const url = this.getApiUrlCall('api/v3/LiveRoutes/InsertGroupAddress');
    this._requestHeaders.append('Content-Type', 'application/json');
    const response = this.http
      .post<boolean>(url, JSON.stringify(group), this._httpOptions)
      .pipe(catchError(this.errorHandler.bind(this)));

    return response;
  }

  /**
   ** Inserts live route group address
   **/
  public ResetLiveRouteGroupAddress(
    group: AddressGroup[]
  ): Observable<boolean> {
    if (group.length === 0) return of(true);

    const url = this.getApiUrlCall(
      'api/v3/LiveRoutes/ResetLiveRouteGroupAddress'
    );
    this._requestHeaders.append('Content-Type', 'application/json');
    const response = this.http
      .post<boolean>(url, JSON.stringify(group), this._httpOptions)
      .pipe(catchError(this.errorHandler.bind(this)));

    return response;
  }

  /**
   * getLiveRouteExtraContents
   **/
  public getRoutesWithLiveRoute(
    routeDate: Date,
    sectorId: number
  ): Observable<any> {
    const url = this.getApiUrlCall('api/v3/LiveRoutes/GetRoutesAndExtraData');

    let params = new HttpParams();
    params = params.append(
      'date',
      this.datePipe.transform(routeDate, 'yyyy-MM-dd')
    );
    params = params.append('sectorId', sectorId.toString());

    return this.http
      .get<any>(url, { params: params, headers: this._requestHeaders })
      .pipe(share());
  }

  /**
   * Inserts and processes parcelHistories
   * Returns true if parcelHistories.length === 0
   */
  public insertParcelHistories(
    parcelHistories: ParcelHistories
  ): Observable<boolean> {
    if (parcelHistories.Length === 0) return of(true);

    const url = this.getApiUrlCall('api/v3/Mobiles/InsertParcelHistories');

    const response = this.http
      .post<boolean>(url, parcelHistories, { headers: this._requestHeaders })
      .pipe(catchError(this.errorHandler.bind(this)));

    return response;
  }

  /**
   * Inserts and processes pickupHistories
   * Returns true if pickupHistories.length === 0
   */
  public insertPickupHistories(
    pickupHistories: PickupHistories
  ): Observable<boolean> {
    if (pickupHistories.Length === 0) return of(true);

    const url = this.getApiUrlCall('api/v3/PickupHistory');

    const response = this.http
      .post<boolean>(url, pickupHistories, { headers: this._requestHeaders })
      .pipe(catchError(this.errorHandler.bind(this)));

    return response;
  }

  /**
   * This function returns a NatUser object
   */
  public getUser(credentials: DTOCredentials): Observable<NatUserStates> {
    const url = this.getApiUrlCall('api/v3/User/GetUser');

    const response = this.http
      .post<NatUserStates>(url, credentials, { headers: this._requestHeaders })
      .pipe(catchError(this.getUserErrorHandler.bind(this)));

    return response;
  }

  /**
   * This function sends a reset password token in a sms or an email to the user
   */
  public sendPasswordResetToken(userID: DTOUserId): Observable<boolean> {
    const url = this.getApiUrlCall('api/v3/User/SendPasswordResetToken');

    const response = this.http
      .post<boolean>(url, userID, { headers: this._requestHeaders })
      .pipe(catchError(this.errorHandler.bind(this)));

    return response;
  }

  /**
   * This function sends a reset password token in a sms or an email to the user
   */
  public sendPasswordResetTokenFromEmail(
    userEmail: DTOUserEmail
  ): Observable<boolean> {
    const url = this.getApiUrlCall(
      'api/v3/User/SendPasswordResetTokenFromEmail'
    );

    const response = this.http
      .post<boolean>(url, userEmail, { headers: this._requestHeaders })
      .pipe(catchError(this.errorHandler.bind(this)));

    return response;
  }

  /**
   * This function sets the new user password if the token and password are valid
   */
  public resetPassword(resetPassword: DTOResetPassword): Observable<boolean> {
    const url = this.getApiUrlCall('api/v3/User/ResetPassword');

    const response = this.http
      .post<boolean>(url, resetPassword, { headers: this._requestHeaders })
      .pipe(catchError(this.errorHandler.bind(this)));

    return response;
  }

  /**
   * This function returns binary data for route PDF
   */
  public getPrintRoutePDF(routeId: number, date: Date): Observable<Blob> {
    const url = this.getApiUrlCall('api/v3/LiveRoutes/PrintRoute');
    let params = new HttpParams();
    params = params.append('date', this.datePipe.transform(date, 'yyyy-MM-dd'));
    params = params.append('routeId', routeId.toString());

    const response = this.http
      .get<Blob>(url, {
        params: params,
        headers: this._requestHeaders,
        responseType: 'blob' as 'json'
      })
      .pipe(catchError(this.errorHandler.bind(this)));

    return response;
  }

  /**
   * This function returns binary data for route PDF
   */
  public getPrintRouteCODPDF(routeId: number, date: Date): Observable<Blob> {
    const url = this.getApiUrlCall('api/v3/LiveRoutes/PrintCod');
    let params = new HttpParams();
    params = params.append('date', this.datePipe.transform(date, 'yyyy-MM-dd'));
    params = params.append('routeId', routeId.toString());

    const response = this.http
      .get<Blob>(url, {
        params: params,
        headers: this._requestHeaders,
        responseType: 'blob' as 'json'
      })
      .pipe(catchError(this.errorHandler.bind(this)));

    return response;
  }

  /**
   * This function prints labels by calling NationexLabelWebPrint
   */
  public printLabels(shippingIds: number[]): Observable<boolean> {
    let ids = '';
    let i = 0;
    for (const id of shippingIds) {
      if (i === 0) {
        ids = `${id}`;
      } else {
        ids = `${ids};${id}`;
      }
      i++;
    }
    const url = `http://127.0.0.1:5000/?id=${ids}`;
    const printWindow = window.open(url, '_blank');
    return of(printWindow !== null);
  }

  /**
   * Gets all the Shipping that had address changed today or yesterday
   **/
  public getAddressChangedShipping(): Observable<number[]> {
    const url = this.getApiUrlCall(
      'api/v3/LiveRoutes/GetAddressChangedShipping'
    );

    let params = new HttpParams();
    params = params.append(
      'date',
      this.datePipe.transform(new Date(), 'yyyy-MM-dd')
    );

    return this.http
      .get<any>(url, { params: params, headers: this._requestHeaders })
      .pipe(catchError(this.errorHandler.bind(this)));
  }

  /**
   * transformToDictionary
   * This is used to transform the array into a dictionnary with a list
   */
  /*private async transformToDictionary<T>(array: Array<T>, indexKey: keyof T) {
    const normalizedObject: any = {};
    for (let i = 0; i < array.length; i++) {
      const key = array[i][indexKey];
      if (!normalizedObject[key]) {
        normalizedObject[key] = [];
      }
      normalizedObject[key].push(array[i]);
    }
    return normalizedObject as { [key: string]: T };
  }*/

  /**
   * Creates a toast, logs error and returns EMPTY
   */
  private errorHandler(error: HttpErrorResponse) {
    this.logger.localstorage(LogLevel.Error, error.message);
    this.toastservice.error(error.message, 'Erreur: API', {
      positionClass: 'toast-bottom-left',
      disableTimeOut: true
    });

    return EMPTY;
  }

  private getUserErrorHandler(error: HttpErrorResponse): Observable<boolean> {
    this.logger.localstorage(LogLevel.Error, error.message);
    if (error.error === 'Credentials are invalid') {
      return of(false);
    } else {
      this.toastservice.error(error.message, 'Erreur: API', {
        positionClass: 'toast-bottom-left',
        disableTimeOut: true
      });
      of(false);
    }
  }

  public getPendings(
    sectorId: number,
    routeDate: Date
  ): Observable<LiveRouteConsol[]> {
    const url = this.getApiUrlCall('api/v3/LiveRoutes/GetPendings');

    let params = new HttpParams();
    params = params.append('_sectorId', sectorId.toString());
    params = params.append(
      '_routeDate',
      this.datePipe.transform(routeDate, 'yyyy-MM-dd')
    );

    const response = this.http
      .get<LiveRouteConsol[]>(url, {
        params: params,
        headers: this._requestHeaders
      })
      .pipe(catchError(this.errorHandler.bind(this)));

    return response;
  }

  /**
   * Returns all Daily Manifest for a specific routeid
   */
  public GetDailyManifestByRouteId(
    routeID: number
  ): Observable<DTODailyManifest[]> {
    // const moment = require('moment');
    // const formattedRouteDate = moment(routeDate).format('YYYY-MM-DD');

    const url = this.getApiUrlCall('api/v3/Manifest');

    let params = new HttpParams();
    params = params.append('id', routeID.toString());

    const response = this.http
      .get<DTODailyManifest[]>(url, {
        params: params,
        headers: this._requestHeaders
      })
      .pipe(catchError(this.errorHandler.bind(this)));

    return response;
  }

  /**
   * Returns all Daily Manifest for a specific  manifest number
   */
  public GetDailyManifestByNumber(
    ManifestNumber: string
  ): Observable<DTODailyManifest[]> {
    // const moment = require('moment');
    // const formattedRouteDate = moment(routeDate).format('YYYY-MM-DD');

    const url = this.getApiUrlCall(
      'api/v3/Manifest/GetParcelsByManifestNumber'
    );

    let params = new HttpParams();
    params = params.append('manifestnumber', ManifestNumber.toString());

    const response = this.http
      .get<DTODailyManifest[]>(url, {
        params: params,
        headers: this._requestHeaders
      })
      .pipe(catchError(this.errorHandler.bind(this)));

    return response;
  }

  /**
   *  Transfers a daily manifest to another tpsl
   */
  public TransferDailyManifest(
    manifest: DTODailyManifest,
    tpsl: number
  ): Observable<DTODailyManifest[]> {
    const url = this.getApiUrlCall('api/v3/Manifest/Transfer?tpsl=') + tpsl;
    const response = this.http
      .post<boolean>(url, JSON.stringify(manifest), this._httpOptions)
      .pipe(catchError(this.errorHandler.bind(this)));
    return response;
  }

  /**
   *  Cancel Daily Manifest
   */
  public CancelDailyManifest(
    manifest: DTODailyManifest
  ): Observable<DTODailyManifest[]> {
    const url = this.getApiUrlCall('api/v3/Manifest/Cancel');
    const response = this.http
      .post<boolean>(url, JSON.stringify(manifest), this._httpOptions)
      .pipe(catchError(this.errorHandler.bind(this)));
    return response;
  }

  /**
   * This function returns binary data for a daily manifest PDF
   */
  public getDailyManifestPDF(manifestId: string): Observable<Blob> {
    const url = this.getApiUrlCall('api/v3/Manifest/PrintDailyManifest');
    let params = new HttpParams();
    params = params.append('manifestid', manifestId);
    const response = this.http
      .get<Blob>(url, {
        params: params,
        headers: this._requestHeaders,
        responseType: 'blob' as 'json'
      })
      .pipe(catchError(this.errorHandler.bind(this)));
    return response;
  }

  public getStopsParcels(
    routeID: number,
    minLiveRouteStatus: number,
    maxLiveRouteStatus: number,
    RouteDate: string
  ): Observable<Stops> {
    const url = this.getApiUrlCall('api/v3/Optimization/GetStopsParcels');
    let params = new HttpParams();
    params = params.append('routeID', routeID.toString());
    params = params.append('minLiveRouteStatus', (0).toString());
    params = params.append('maxLiveRouteStatus', (4).toString());
    params = params.append('RouteDate', RouteDate);
    return this.http.get<Stops>(url, { params: params });
  }

  public getSectorCompress(
    routeID: number,
    RouteDate: string
  ): Observable<SectorCompress> {
    const url = this.getApiUrlCall('api/v3/Optimization/GetSectorCompress');
    let params = new HttpParams();
    params = params.append('SectorId', routeID.toString());
    params = params.append('routeDate', RouteDate);
    return this.http.get<SectorCompress>(url, { params: params });
  }

  public getStopsOnHoldParcels(
    routeID: number,
    minLiveRouteStatus: number,
    maxLiveRouteStatus: number,
    RouteDate: string,
    sector: number
  ): Observable<Stops> {
    const url = this.getApiUrlCall('api/v3/Mobiles/GetOnHoldStopsParcels');
    let params = new HttpParams();
    params = params.append('sectorID', sector.toString());
    params = params.append('routeDate', RouteDate);
    return this.http.get<Stops>(url, { params: params });
  }

  public GetParcelHistoriesInfo(
    parcelID: number,
    language: number
  ): Observable<ParcelHistory[]> {
    const url = this.getApiUrlCall('api/v3/Mobiles/GetParcelHistoriesInfo');
    let params = new HttpParams();
    params = params.append('parcelID', parcelID.toString());
    params = params.append('language', language.toString());
    return this.http.get<ParcelHistory[]>(
      url,
      { params: params } /*, { params: params }*/
    );
  }

  public GetOnHoldStopsParcels(
    sectorID: number,
    RouteDate: string
  ): Observable<Stops> {
    const url = this.getApiUrlCall('api/v3/Mobiles/GetOnHoldStopsParcels');
    let params = new HttpParams();
    params = params.append('sectorID', sectorID.toString());
    params = params.append('routeDate', RouteDate);
    return this.http.get<Stops>(url, { params: params });
  }

  public GetRouteePolyline(RouteID: number): Observable<string> {
    const url = this.getApiUrlCall('api/v3/Optimization/GetRoutePolyline');
    let params = new HttpParams();
    params = params.append('routeID', RouteID.toString());
    return this.http.get<string>(url, { params: params });
  }

  public SectorCompressByDate(
    sectorID: number,
    RouteDate: string,
    UserID: number
  ): Observable<SectorCompress> {
    const url = this.getApiUrlCall('api/v3/Mobiles/SectorCompressByDate');
    let params = new HttpParams();
    params = params.append('SectorID', sectorID.toString());
    params = params.append('RouteDate', RouteDate);
    params = params.append('UserID', UserID.toString());
    return this.http.get<SectorCompress>(url, { params: params });
  }

  public TransferStopToRoute(
    NewRouteId: number,
    RouteDate: Date,
    RouteID: number,
    NoStop: number,
    LiveRouteStatus: number,
    UserID: number,
    Exception: number,
    ConsolId: number,
    StopsList: Stop[]
  ): Observable<boolean> {
    const url = this.getApiUrlCall(
      'api/v3/Optimization/TransferStopToRoute?NewRouteId=' +
      NewRouteId +
      '&RouteDate=' +
      this.datePipe.transform(RouteDate, 'yyyy-MM-dd') +
      '&RouteID=' +
      RouteID +
      '&NoStop=' +
      NoStop +
      '&LiveRouteStatus=' +
      LiveRouteStatus +
      '&UserID=' +
      UserID +
      '&Exception=' +
      Exception +
      '&ConsolId=' +
      ConsolId
    );
    StopsList = null;
    /*let params = new HttpParams();
    params = params.append('NewRouteId', NewRouteId.toString());
    params = params.append('RouteDate', formattedRouteDate.toString());
    params = params.append('RouteID', RouteID.toString());
    params = params.append('NoStop', NoStop.toString());*/
    return this.http
      .post<boolean>(
        url,
        JSON.stringify(StopsList),
        this._httpOptions /*, { params: params }*/
      )
      .pipe(catchError(this.errorHandler.bind(this)));
  }

  public BatchTransferStopToRoute(
    NewRouteId: number,
    RouteDate: Date,
    RouteID: number,
    NoStop: number,
    LiveRouteStatus: number,
    UserID: number,
    Exception: number,
    SectorID: number,
    StopsList: Stop[]
  ): Observable<TpslRouteStops> {
    const url = this.getApiUrlCall(
      'api/v3/Mobiles/BatchTransferStopOnHold?NewRouteId=' + //Cpomit
      NewRouteId +
      '&RouteDate=' +
      this.datePipe.transform(RouteDate, 'yyyy-MM-dd') +
      '&RouteID=' +
      RouteID +
      '&NoStop=' +
      NoStop +
      '&LiveRouteStatus=' +
      LiveRouteStatus +
      '&UserID=' +
      UserID +
      '&Exception=' +
      Exception +
      '&SectorID=' +
      SectorID
    );
    /*let params = new HttpParams();
    params = params.append('NewRouteId', NewRouteId.toString());
    params = params.append('RouteDate', formattedRouteDate.toString());
    params = params.append('RouteID', RouteID.toString());
    params = params.append('NoStop', NoStop.toString());*/
    return this.http
      .post<number>(
        url,
        JSON.stringify(StopsList),
        this._httpOptions /*, { params: params }*/
      )
      .pipe(catchError(this.errorHandler.bind(this)));
  }

  public BatchTransferStopDate(
    NewRouteDate: string,
    RouteDate: Date,
    RouteID: number,
    NoStop: number,
    UserID: number,
    StopsList: Stop[]
  ): Observable<TpslRouteStops> {
    const url = this.getApiUrlCall(
      'api/v3/Mobiles/BatchTransferStopDate?NewRouteDate=' +
      NewRouteDate +
      '&RouteDate=' +
      this.datePipe.transform(RouteDate, 'yyyy-MM-dd') +
      '&RouteID=' +
      RouteID +
      '&NoStop=' +
      NoStop +
      '&UserID=' +
      UserID
    );
    /*let params = new HttpParams();
    params = params.append('NewRouteId', NewRouteId.toString());
    params = params.append('RouteDate', formattedRouteDate.toString());
    params = params.append('RouteID', RouteID.toString());
    params = params.append('NoStop', NoStop.toString());*/
    return this.http
      .post<number>(
        url,
        JSON.stringify(StopsList),
        this._httpOptions /*, { params: params }*/
      )
      .pipe(catchError(this.errorHandler.bind(this)));
  }

  public moveParcelToRoute(
    parcelId: number,
    routeId: number,
    noStop: number,
    addToExisting: boolean,
    UserID: number
  ): Observable<LiveRouteConsol> {
    const url = this.getApiUrlCall('api/v3/LiveRoutes/MoveParcelToRoute');
    const dtoParcelRoute = new DTOParcelRoute();
    dtoParcelRoute.ParcelID = parcelId;
    dtoParcelRoute.RouteID = routeId;
    dtoParcelRoute.NoStop = noStop;
    dtoParcelRoute.AddToExisting = addToExisting;
    dtoParcelRoute.UserID = UserID;
    const response = this.http.put<LiveRouteConsol>(url, dtoParcelRoute);
    return response;
  }

  public WebPages(ParentID: number, LanguageID: number): Observable<WebPage[]> {
    const url = this.getApiUrlCall('api/v3/Mobiles/WebPages');
    let params = new HttpParams();
    params = params.append('ParentID', ParentID.toString());
    params = params.append('LanguageID', LanguageID.toString());
    return this.http.get<WebPage[]>(url, { params: params });
  }

  public WebPage(WebPageID: number, LanguageID: number): Observable<WebPage> {
    const url = this.getApiUrlCall('api/v3/Mobiles/WebPage');
    let params = new HttpParams();
    params = params.append('WebPageID', WebPageID.toString());
    params = params.append('LanguageID', LanguageID.toString());
    return this.http.get<WebPage>(url, { params: params });
  }

  public UpdateWebPage(webPage: WebPage, UserID: number): Observable<WebPage> {
    const url = this.getApiUrlCall('api/v3/Mobiles/WebPage');
    let params = new HttpParams();
    params = params.append('UserID', UserID.toString());
    return this.http.put<WebPage>(url, webPage, { params: params });
  }

  public InsertWebPage(webPage: WebPage, UserID: number): Observable<WebPage> {
    const url = this.getApiUrlCall('api/v3/Mobiles/WebPage');
    let params = new HttpParams();
    params = params.append('UserID', UserID.toString());
    return this.http.post<WebPage>(url, webPage, { params: params });
  }

  public GetRoute(RouteID: number): Observable<RouteModel> {
    const url = this.getApiUrlCall('api/v3/Mobiles/Route');
    let params = new HttpParams();
    params = params.append('RouteID', RouteID.toString());
    return this.http.get<RouteModel>(url, { params: params });
  }

  public GetDriversRouteIds(username: string): Observable<number[]> {
    const url = this.getApiUrlCall('api/v3/Mobiles/GetDriversRouteIds');
    let params = new HttpParams();
    params = params.append('username', username);
    return this.http.get<number[]>(url, { params: params });
  }

  public UpdateRoute(
    RouteID: number,
    routeDriverName: string,
    routeDriverPhone: string,
    routeDriverLanguage: string
  ): Observable<boolean> {
    const url = this.getApiUrlCall(
      'api/v3/Mobiles/UpdateRoute?RouteID=' +
      RouteID.toString() +
      '&routeDriverName=' +
      routeDriverName.toString() +
      '&routeDriverPhone=' +
      routeDriverPhone.toString() +
      '&routeDriverLanguage=' +
      routeDriverLanguage.toString()
    );
    return this.http.post<boolean>(url, {});
  }

  public updateDriver(_user: MobileUser): Observable<boolean> {
    const url = this.getApiUrlCall('api/v3/Mobiles/UpdateDriver');
    const response = this.http
      .post<boolean>(url, _user, { headers: this._requestHeaders })
      .pipe(catchError(this.errorHandler.bind(this)));
    return response;
  }

  public driverExists(username: string): Observable<boolean> {
    const url = this.getApiUrlCall('api/v3/Mobiles/DriverExists');
    let params = new HttpParams();
    params = params.append('username', username.toString());
    return this.http.get<boolean>(url, { params: params });
  }

  public GetLocationPostalCode5Length(
    RouteID: number
  ): Observable<LocationModel[]> {
    const url = this.getApiUrlCall('api/v3/Mobiles/LocationPostalCode5Length');
    let params = new HttpParams();
    params = params.append('RouteID', RouteID.toString());
    return this.http.get<LocationModel[]>(url, { params: params });
  }

  public GetLocationPostalCode(
    routeID: number,
    digitCount: number
  ): Observable<LocationModel[]> {
    const url = this.getApiUrlCall('api/v3/Mobiles/LocationPostalCode');
    let params = new HttpParams();
    params = params.append('routeID', routeID.toString());
    params = params.append('digitCount', digitCount.toString());
    return this.http.get<LocationModel[]>(url, { params: params });
  }

  public GetLocationException(
    routeID: number,
    digitCount: number,
    customerID: number,
    activeHourFrom: number,
    activeHourTo: number
  ): Observable<LocationModel[]> {
    const url = this.getApiUrlCall('api/v3/Mobiles/LocationException');
    let params = new HttpParams();
    params = params.append('routeID', routeID.toString());
    params = params.append('digitCount', digitCount.toString());
    params = params.append('customerID', customerID.toString());
    params = params.append('activeHourFrom', activeHourFrom.toString());
    params = params.append('activeHourTo', activeHourTo.toString());
    return this.http.get<LocationModel[]>(url, { params: params });
  }

  public UpdateLocationPostalCode5Length(
    OldRouteID: number,
    NewRouteID: number,
    Digits5LenghtPostalCode: string
  ): Observable<boolean> {
    const url = this.getApiUrlCall(
      'api/v3/Mobiles/UpdateLocationPostalCode5Length'
    );
    let params = new HttpParams();
    params = params.append('OldRouteID', OldRouteID.toString());
    params = params.append('NewRouteID', NewRouteID.toString());
    params = params.append('Digits5LenghtPostalCode', Digits5LenghtPostalCode);
    return this.http.get<boolean>(url, { params: params });
  }

  public UpdateLocationPostalPriority(
    RouteID: number,
    OldPriority: number,
    NewPriority: number,
    PostalCodeDigit: string
  ): Observable<boolean> {
    const url = this.getApiUrlCall(
      'api/v3/Mobiles/UpdateLocationPostalPriority'
    );
    let params = new HttpParams();
    params = params.append('RouteID', RouteID.toString());
    params = params.append('OldPriority', OldPriority.toString());
    params = params.append('NewPriority', NewPriority.toString());
    params = params.append('PostalCodeDigit', PostalCodeDigit);
    return this.http.get<boolean>(url, { params: params });
  }

  public AttachLocationPostalPriority(
    RouteID: number,
    OldPriority: number,
    NewPriority: number,
    PostalCodeDigit: string
  ): Observable<boolean> {
    const url = this.getApiUrlCall(
      'api/v3/Mobiles/AttachLocationPostalPriority'
    );
    let params = new HttpParams();
    params = params.append('RouteID', RouteID.toString());
    params = params.append('OldPriority', OldPriority.toString());
    params = params.append('NewPriority', NewPriority.toString());
    params = params.append('PostalCodeDigit', PostalCodeDigit);
    return this.http.get<boolean>(url, { params: params });
  }

  public UpdateLocationRouteID(
    RouteID: number,
    NewRouteID: number,
    PostalCodeDigit: string
  ): Observable<boolean> {
    const url = this.getApiUrlCall('api/v3/Mobiles/UpdateLocationRouteID');
    let params = new HttpParams();
    params = params.append('RouteID', RouteID.toString());
    params = params.append('NewRouteID', NewRouteID.toString());
    params = params.append('PostalCodeDigit', PostalCodeDigit);
    return this.http.get<boolean>(url, { params: params });
  }

  public UpdateLocationRoute(
    RouteID: number,
    NewRouteID: number,
    Priority: number,
    PostalCodeDigit: string
  ): Observable<boolean> {
    const url = this.getApiUrlCall('api/v3/Mobiles/UpdateLocationRouteID');
    let params = new HttpParams();
    params = params.append('RouteID', RouteID.toString());
    params = params.append('NewRouteID', NewRouteID.toString());
    params = params.append('Priority', Priority.toString());

    params = params.append('PostalCodeDigit', PostalCodeDigit);
    return this.http.get<boolean>(url, { params: params });
  }

  public UpdateLocationExceptionRoute(
    RouteID: number,
    NewRouteID: number,
    Priority: number,
    PostalCodeDigit: string,
    CustomerID: number,
  ): Observable<boolean> {
    const url = this.getApiUrlCall('api/v3/Mobiles/UpdateLocationExceptionRouteID');
    let params = new HttpParams();
    params = params.append('RouteID', RouteID.toString());
    params = params.append('NewRouteID', NewRouteID.toString());
    params = params.append('Priority', Priority.toString());
    params = params.append('PostalCodeDigit', PostalCodeDigit);
    params = params.append('CustomerID', CustomerID.toString());
    return this.http.get<boolean>(url, { params: params });
  }


  public UpdateLocationPostalCodeRoute(
    OldRouteID: number,
    NewRouteID: number,
    PostalCodeDigit: string,
    Priority: number
  ): Observable<boolean> {
    const url = this.getApiUrlCall(
      'api/v3/Mobiles/UpdateLocationPostalCodeRoute'
    );
    let params = new HttpParams();
    params = params.append('OldRouteID', OldRouteID.toString());
    params = params.append('NewRouteID', NewRouteID.toString());
    params = params.append('PostalCodeDigit', PostalCodeDigit);
    params = params.append('Priority', Priority.toString());
    return this.http.get<boolean>(url, { params: params });
  }

  public UpdateLocationException(
    OldRouteID: number,
    NewRouteID: number,
    OldPriority: number,
    NewPriority: number,
    PostalCodeDigit: string,
    CustomerID: number
  ): Observable<boolean> {
    const url = this.getApiUrlCall('api/v3/Mobiles/UpdateLocationException');
    let params = new HttpParams();
    console.log("OldRouteID", OldRouteID);
    console.log("NewRouteID", NewRouteID);
    console.log("OldPriority", OldPriority);
    console.log("NewPriority", NewPriority);
    console.log("PostalCodeDigit", PostalCodeDigit);
    console.log("CustomerID", CustomerID);
    params = params.append('OldRouteID', OldRouteID.toString());
    params = params.append('NewRouteID', NewRouteID.toString());
    params = params.append('OldPriority', OldPriority.toString());
    params = params.append('NewPriority', NewPriority.toString());
    params = params.append('PostalCodeDigit', PostalCodeDigit);
    params = params.append('CustomerID', CustomerID.toString());
    return this.http.get<boolean>(url, { params: params });
  }

  public DevicePositionHistories(
    RouteID: number,
    DateInsert: Date
  ): Observable<DevicePositionHistory[]> {
    const url = this.getApiUrlCall('api/v3/Mobiles/DevicePositionHistories');
    let params = new HttpParams();
    params = params.append('_routeID', RouteID.toString());
    params = params.append(
      '_dateInsert',
      this.datePipe.transform(DateInsert, 'yyyy-MM-dd').toString()
    );
    return this.http.get<DevicePositionHistory[]>(url, { params: params });
  }

  /**
   *  Post Address Change Code(32)
   */
  public InsertAddressChangeCode32(
    newaddress: DtoModifAddress
  ): Observable<number> {
    const url = this.getApiUrlCall('api/v3/Mobiles/ModifyAddress');
    //const url = 'http://localhost:53319/api/v3/ParcelHistory/ModifyAddress';
    newaddress.ExceptionCode = 132;
    const response = this.http
      .post<number>(url, JSON.stringify(newaddress), this._httpOptions)
      .pipe(catchError(this.errorHandler.bind(this)));
    return response;
  }

  public InsertConsignee(
    _sequenceID: number,
    _customerID: number,
    _ncAccount: string,
    _ncName: string,
    _ncAddr1: string,
    _ncAddr2: string,
    _ncCity: string,
    _ncProvince: string,
    _ncPostal: string,
    _ncPHone: string,
    _ncEmail: string
  ): Observable<number> {
    const url = this.getApiUrlCall('api/v3/Mobiles/InsertConsignee');
    let params = new HttpParams();
    params = params.append('_sequenceID', _sequenceID.toString());
    params = params.append('_customerID', _customerID.toString());
    params = params.append('_ncAccount', _ncAccount.toString());
    params = params.append('_ncName', _ncName.toString());
    params = params.append('_ncAddr1', _ncAddr1.toString());
    params = params.append('_ncAddr2', _ncAddr2.toString());
    params = params.append('_ncCity', _ncCity.toString());
    params = params.append('_ncProvince', _ncProvince.toString());
    params = params.append('_ncPostal', _ncPostal.toString());
    params = params.append('_ncPHone', _ncPHone.toString());
    params = params.append('_ncEmail', _ncEmail.toString());
    return this.http.get<number>(url, { params: params });
  }

  public CreateAccount(Account: MobileUser): Observable<boolean> {
    const url = this.getApiUrlCall('api/v3/User/Create');
    const response = this.http
      .post<boolean>(url, Account, { headers: this._requestHeaders })
      .pipe(catchError(this.errorHandler.bind(this)));

    return response;
  }

  public GetDropOffPointByRoute(_routeID: number): Observable<DropOffPoint[]> {
    const url = this.getApiUrlCall('api/v3/Mobiles/GetDropOffPointByRoute');
    let params = new HttpParams();
    params = params.append('_routeID', _routeID.toString());
    return this.http.get<DropOffPoint[]>(url, { params: params });
  }

  public LocationExceptionClient(sectorID: number): Observable<Customer[]> {
    const url = this.getApiUrlCall('api/v3/Mobiles/LocationExceptionClient');
    let params = new HttpParams();
    params = params.append('sectorID', sectorID.toString());
    return this.http.get<Customer[]>(url, { params: params });
  }

  public UpdateDropOffPointByRoute(
    _routeID: number,
    _dropOffPointID: number,
    _dropOffPointType: number
  ): Observable<boolean> {
    const url = this.getApiUrlCall('api/v3/Mobiles/UpdateDropOffPointByRoute');
    let params = new HttpParams();
    params = params.append('_routeID', _routeID.toString());
    params = params.append('_dropOffPointID', _dropOffPointID.toString());
    params = params.append('_dropOffPointType', _dropOffPointType.toString());
    return this.http.get<boolean>(url, { params: params });
  }

  public UpdateLiveRouteStatusLocked(
    _routeID: number,
    _userID: number,
    _routeDate: Date,
    _hasBeenLocked: Boolean
  ): Observable<boolean> {
    const url = this.getApiUrlCall(
      'api/v3/Mobiles/UpdateLiveRouteStatusLocked'
    );
    let params = new HttpParams();
    params = params.append('_routeID', _routeID.toString());
    params = params.append('_userID', _userID.toString());
    params = params.append(
      '_routeDate',
      this.datePipe.transform(_routeDate, 'yyyy-MM-dd').toString()
    );
    params = params.append('_hasBeenLocked', _hasBeenLocked.toString());
    return this.http.get<boolean>(url, { params: params });
  }

  public UpdateLiveRouteStatus(
    _routeID: number,
    _userID: number,
    _routeDate: Date,
    _liveRouteStatus: string
  ): Observable<boolean> {
    const url = this.getApiUrlCall('api/v3/Mobiles/UpdateLiveRouteStatus');
    let params = new HttpParams();
    params = params.append('_routeID', _routeID.toString());
    params = params.append('_userID', _userID.toString());
    params = params.append(
      '_routeDate',
      this.datePipe.transform(_routeDate, 'yyyy-MM-dd').toString()
    );
    params = params.append('_liveRouteStatus', _liveRouteStatus.toString());
    return this.http.get<boolean>(url, { params: params });
  }

  public GetPhotos(waybill: number): Observable<number[]> {
    const url = this.getApiUrlCall('api/v3/Mobiles/GetPhotos');
    let params = new HttpParams();
    params = params.append('waybill', waybill.toString());
    return this.http.get<number[]>(url, { params: params });
  }

  public GetPhoto(photoID: number): Observable<Photo> {
    const url = this.getApiUrlCall('api/v3/Mobiles/GetPhoto');
    let params = new HttpParams();
    params = params.append('photoID', photoID.toString());
    return this.http.get<Photo>(url, { params: params });
  }

  public GetNonCompletedStops(sector: number): Observable<Stops> {
    const url = this.getApiUrlCall('api/v3/Mobiles/GetListStopSector');
    let params = new HttpParams();
    params = params.append('sectorID', sector.toString());
    let currentDate = new Date();
    let dateString = currentDate.toISOString();
    let currentDateFormated = this.datePipe.transform(dateString, 'yyyy-MM-dd');
    params = params.append('routeDate', currentDateFormated);
    return this.http.get<Stops>(url, { params: params });
  }

  public GetShipment(
    shipmentId: number,
    userId: string,
    key: string
  ): Observable<DTOShipment> {
    let httpClient = new HttpClient(this.handler);
    const auth = `${userId}:${key}`;
    const url = this.getApiUrlCall(
      `api/v4/Shipments/${shipmentId}/?includeAll=true&parcels=true&tracking=true&consol=true&images=true`
    );
    return httpClient.get<DTOShipment>(url, {
      headers: new HttpHeaders().set('Authorization', `Basic ${btoa(auth)}`)
    });
  }

  public UpdateShipment(
    shipment: DTOShipment,
    userId: string,
    key: string,
    reactivate: boolean
  ): Observable<boolean> {
    let httpClient = new HttpClient(this.handler);
    const auth = `${userId}:${key}`;
    const url = this.getApiUrlCall(
      `api/v4/Shipments/${shipment.ShipmentId}/?reactivate=${reactivate}`
    );
    const response = httpClient.put<boolean>(url, shipment, {
      headers: new HttpHeaders().set('Authorization', `Basic ${btoa(auth)}`)
    });
    return response;
  }

  public InsertParcelHistories(
    parcelHistories: DTOParcelHistories,
    userId: string,
    key: string
  ): Observable<boolean> {
    let httpClient = new HttpClient(this.handler);
    const auth = `${userId}:${key}`;
    const url = this.getApiUrlCall(`api/v4/ParcelHistory/`);
    const response = httpClient.post<boolean>(url, parcelHistories, {
      headers: new HttpHeaders().set('Authorization', `Basic ${btoa(auth)}`)
    });
    return response;
  }

  public GetListShipments(
    shipmentAdvancedSearch: DTOShipmentAdvancedSearch,
    userId: string,
    key: string
  ): Observable<DTOShipment[]> {
    let httpClient = new HttpClient(this.handler);
    const auth = `${userId}:${key}`;
    const url = this.getApiUrlCall(`api/v4/Shipments/advanced/`);

    const response = httpClient.post<DTOShipment[]>(
      url,
      shipmentAdvancedSearch,
      {
        headers: new HttpHeaders().set('Authorization', `Basic ${btoa(auth)}`)
      }
    );
    return response;
  }

  public GetPODContacts(
    ShipmentId: number,
    userId: string,
    key: string
  ): Observable<DTOPODContact[]> {
    let httpClient = new HttpClient(this.handler);
    const auth = `${userId}:${key}`;
    const url = this.getApiUrlCall(
      `api/v4/Customers/${ShipmentId}/podContacts`
    );
    const response = httpClient.get<DTOPODContact[]>(url, {
      headers: new HttpHeaders().set('Authorization', `Basic ${btoa(auth)}`)
    });
    return response;
  }

  public SearchCustomer(
    query: string,
    userId: string,
    key: string
  ): Observable<DTOCustomerInfo[]> {
    let httpClient = new HttpClient(this.handler);
    const auth = `${userId}:${key}`;
    const url = this.getApiUrlCall(`api/v4/Customers/search?query=${query}`);
    const response = httpClient.get<DTOCustomerInfo[]>(url, {
      headers: new HttpHeaders().set('Authorization', `Basic ${btoa(auth)}`)
    });
    return response;
  }

  public GetCRMUser(userId: string, key: string): Observable<string> {
    let httpClient = new HttpClient(this.handler);
    const auth = `${userId}:${key}`;
    const url = this.getApiUrlCall(`api/v4/Users/${userId}`);
    const response = httpClient.get<string>(url, {
      headers: new HttpHeaders().set('Authorization', `Basic ${btoa(auth)}`)
    });
    return response;
  }

  public SendPODContacts(
    ShipmentId: number,
    userId: string,
    emails: string,
    key: string
  ): Observable<boolean> {
    let httpClient = new HttpClient(this.handler);
    const auth = `${userId}:${key}`;
    const url = this.getApiUrlCall(
      `api/v4/Shipments/${ShipmentId}/sendPOD?userId=${userId}&emails=${emails}`
    );
    const response = httpClient.post<boolean>(url, null, {
      headers: new HttpHeaders().set('Authorization', `Basic ${btoa(auth)}`)
    });

    return response;
  }

  public GetLabels(
    ShipmentId: number,
    userId: string,
    key: string
  ): Observable<Blob> {
    let httpClient = new HttpClient(this.handler);
    const url = this.getApiUrlCall(`api/v4/Shipments/${ShipmentId}/labels`);
    const auth = `${userId}:${key}`;
    const response = httpClient
      .get<Blob>(url, {
        headers: new HttpHeaders().set('Authorization', `Basic ${btoa(auth)}`),
        responseType: 'blob' as 'json'
      })
      .pipe(catchError(this.errorHandler.bind(this)));

    return response;
  }

  public CancelException(
    dtoParcelHistories: DTOParcelHistories,
    userId: string,
    key: string
  ): Observable<boolean> {
    let httpClient = new HttpClient(this.handler);
    const auth = `${userId}:${key}`;
    const url = this.getApiUrlCall(`api/v4/ParcelHistory/void`);
    const response = httpClient.put<boolean>(url, dtoParcelHistories, {
      headers: new HttpHeaders().set('Authorization', `Basic ${btoa(auth)}`)
    });
    return response;
  }

  public CreateShipment(
    dtoShipmentCreate: DTOShipmentCreate,
    userId: string,
    key: string
  ): Observable<DTOShipmentCreated> {
    let httpClient = new HttpClient(this.handler);
    const auth = `${userId}:${key}`;
    const url = this.getApiUrlCall(`api/v4/Shipments`);
    const response = httpClient.post<DTOShipmentCreated>(
      url,
      dtoShipmentCreate,
      {
        headers: new HttpHeaders().set('Authorization', `Basic ${btoa(auth)}`)
      }
    );
    return response;
  }
  /**
   * This function returns binary data for route PDF

  public getPrintRoutePDF(routeId: number, date: Date): Observable<Blob> {
    const url = this.getApiUrlCall('api/v3/LiveRoutes/PrintRoute');
    let params = new HttpParams();
    params = params.append('date', this.datePipe.transform(date, 'yyyy-MM-dd'));
    params = params.append('routeId', routeId.toString());

    const response = this.http
      .get<Blob>(url, {
        params: params,
        headers: this._requestHeaders,
        responseType: 'blob' as 'json'
      })
      .pipe(catchError(this.errorHandler.bind(this)));

    return response;
  } */

  sendNotification(channel: string, notificationType: ENotificationType, routeId: number): Observable<boolean> {
    const url = this.getApiUrlCall('api/v4/Notification/SendNotification');
    let notification = {
      Channel: channel,
      Type: notificationType,
      RouteId: routeId
    }

    return this.http.post<boolean>(url, notification);
  }

  getCustomers() {
    const url = this.getApiUrlCall('api/v3/Mobiles/GetCustomers');

    return this.http.get<any>(url);
  }


  postPickup(routeId: number, customerId: number, date: any, time: any) {

    let body = {
      RouteID: routeId,
      CustomerId: customerId,
      RouteDate: date,
      PickUpTime: time
    }

    const url = this.getApiUrlCall('api/v3/PickupHistory/PostPickup');

    return this.http.post<any>(url, body);
  }

  getGeoTabUsers(){
    const url = this.getApiUrlCall("api/v3/Geotab/getGeotabUsers");

    return this.http.get<Array<GeoTabUser>>(url);
  }

  setGeoTabUser(geoTabUserId : string, routeId : number, agentEmail : string, selectorAgentNo : number){

    const url = this.getApiUrlCall("api/v3/Geotab/assignGeoTabUserToRoute");
    
    let params = new HttpParams();
    params = params.append('geoTabUserId', geoTabUserId);
    params = params.append('routeId', routeId.toString());
    params = params.append('agentEmail', agentEmail);
    params = params.append('selectorAgentNo', selectorAgentNo.toString());

    return this.http.post(url, {}, { params : params });

  }

  getGeoTabUserAssignByRoute(routeId : number) : Observable<GeoTabUser>{

    const url = this.getApiUrlCall("api/v3/Geotab/getGeoTabUserAssignByRoute");
    
    let params = new HttpParams();
    params = params.append('routeId', routeId.toString());

    return this.http.post<GeoTabUser>(url, {}, { params : params });

  }

  getGeoTabUserAssignBySector(sectorId : number) : Observable<Array<GeoTabUserAssign>>{

    const url = this.getApiUrlCall("api/v3/Geotab/getGeoTabUserAssignBySector");
    
    let params = new HttpParams();
    params = params.append('sectorId', sectorId.toString());

    return this.http.post<Array<GeoTabUserAssign>>(url, {}, { params : params });

  }
  

  


  checkJwtToken(): Observable<boolean> {
    console.log("api check token")
    const url = this.getApiUrlCall("api/v3/Mobiles/CheckJwtToken");

    // Création des headers avec le token d'autorisation
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${localStorage.getItem("jwtToken")}`
    });

    // Envoi de la requête GET avec les headers
    return this.http.get<boolean>(url, { headers: headers }).pipe(
      catchError(err => {
        console.error('Token check failed', err);
        return [false]; // Return false if there's an error
      })
    );
  }

  refreshTpslRouteToken(): Observable<{ token: string }> {
    return this.http.post<{ token: string }>(environment.apiUrlV5 + 'api/tpsl-route/session/refresh', {});
  }

}
